"use client"

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts"

const chartData = [
  { month: "January", Apps: 186 },
  { month: "February", Apps: 305 },
  { month: "March", Apps: 237 },
  { month: "April", Apps: 73 },
  { month: "May", Apps: 209 },
  { month: "June", Apps: 214 },
]

export default function LineChartSample() {
  return (
    <div style={{ minHeight: "200px", width: "100%", padding: "1rem", background: "black" }}>
      <ResponsiveContainer width="100%" height={500}>
        <LineChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
        >
          <CartesianGrid
            stroke="#e5e7eb"
            strokeDasharray="3 3"
            vertical={false}
          />
          <XAxis
            dataKey="month"
            stroke="#6b7280" // Color for the text
            fontSize={12}
            tickLine={false} // No tick marks (removes any "dots")
            axisLine={{ stroke: "#6b7280", strokeWidth: 1, strokeDasharray: "0" }} // Solid line
          />
          <YAxis
            stroke="#6b7280"
            fontSize={12}
            tickLine={false}
            axisLine={false}
            tickFormatter={(value) => `${value}`}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            }}
            cursor={false} // Removes the vertical hover line
          />
          <Legend
            wrapperStyle={{
              paddingTop: "10px",
              fontSize: "14px",
              color: "#6b7280",
            }}
          />
          <Line
            type="monotone" // Smooth curve; use "linear" for straight lines
            dataKey="Apps"
            stroke="#2563eb" // Line color
            strokeWidth={2}
            dot={{ r: 4, fill: "#2563eb" }} // Dots at data points
            activeDot={{ r: 6 }} // Larger dot on hover
            isAnimationActive={false}
          />
          {/* <Line
            type="monotone" // Smooth curve; use "linear" for straight lines
            dataKey="mobile"
            stroke="#60a5fa" // Line color
            strokeWidth={2}
            dot={{ r: 4, fill: "#60a5fa" }} // Dots at data points
            activeDot={{ r: 6 }} // Larger dot on hover
            isAnimationActive={false}
          /> */}
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}